import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import EmbedMatomo from 'containers/Results/WebsiteResults/EmbedMatomo';
import EmptyMessage from 'components/EmptyMessage';

const SessionRecordingReplay = () => {
  const match = useRouteMatch('/data-sources/:dataSourceId/hsr/session-recordings/:matomoHsrId/:recordId');

  const urlParams = useMemo(() => ({
    module: 'HeatmapSessionRecording',
    action: 'replayRecording',
    idSiteHsr: match.params.matomoHsrId,
    idLogHsr: match.params.recordId,
  }), [match.params.matomoHsrId, match.params.recordId]);

  return (
    urlParams.idLogHsr ? <EmbedMatomo urlParams={urlParams} disableGlobalParams /> : <EmptyMessage />
  );
};

export default SessionRecordingReplay;
